/**
 * 
 * @param {string|string[]} selectors
 * @param {Object} options
 * @param {Function} options.onClose
 * @param {number} [options.delay=100]
 * @param {boolean} [options.lockScroll=true]
 */
export function useClickOutsideClose ( selectors, options ) {
  const {
    onClose,
    delay = 100,
    lockScroll = true
  } = options || {};

  const isMounted = ref( false );
  const closeFn = ref( () => { } );

  if ( typeof onClose === 'function' ) {
    closeFn.value = onClose;
  } else {
    // console.warn('[useClickOutsideClose] onClose is not a function');
  }

  const handleClickOutside = ( event ) => {
    const target = event.target;

    const isInsideAnySelector = Array.isArray( selectors )
      ? selectors.some( selector => target.closest( selector ) )
      : target.closest( selectors );

    if ( !isInsideAnySelector && isMounted.value ) {
      closeFn.value( event );
    }
  };

  onMounted( () => {
    if ( lockScroll ) {
      document.body.style.overflow = 'hidden';
    }
    setTimeout( () => {
      isMounted.value = true;
      document.addEventListener( 'click', handleClickOutside );
    }, delay );
  } );

  onUnmounted( () => {
    if ( lockScroll ) {
      document.body.style.overflow = '';
    }
    document.removeEventListener( 'click', handleClickOutside );
  } );
}
